<template>
    <div class="tab-items-container">
        <slot></slot>
        <!-- <div class="splide" :id="id">
            <div class="splide__track flex justify-center w-full">
                <ul class="splide__list">
                    <slot></slot>
                </ul>
            </div>
        </div> -->
    </div>
</template>

<script>
// import Splide from "@splidejs/splide";
export default {
    name: "VTabItems",
    props: {
        id: {
            type: String,
            required: true
        },
        tab: {
            type: [String, Number],
            default: 0
        },
        autoHeight: {
            type: Boolean,
            default: true
        }
    },
    data: function () {
        return {
            options: {},
            splide: null,
        };
    },
    computed: {

    },
    watch: {
        tab: function (val) {
            this.next(val)
        }
    },
    created: function () {
        this.options = {
            perPage: 1,
            perMove: 1,
            arrows: false,
            loop: false,
            pagination: false,
            drag: false,
            autoHeight: this.autoHeight,
            autoWidth: true,
            start: this.tab
        };
    },
    mounted: function () {
        // this.splide = new Splide(`#${this.id}.splide`, this.options).mount();
        // this.splide.on('active', function (e) {
        //     console.log(e)
        //     e.slide.parentElement.style.height = e.slide.getHeight() + 'px'
        // })
    },
    beforeUnmount: function () {
        // this.splide.destroy();
    },
    methods: {
        next() {
            // this.splide.go(this.tab);
        },
    }
}
</script>
